import { render, staticRenderFns } from "./bankAccounts.vue?vue&type=template&id=3e0a697c&scoped=true&"
import script from "./bankAccounts.vue?vue&type=script&lang=ts&"
export * from "./bankAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a697c",
  null
  
)

export default component.exports